module.exports = __webpack_public_path__ + "static/media/arrow_right.ab70d552.svg";